// extracted by css-extract-rspack-plugin
export default {"scanned":"HtXI4oXnUnYqiDaV","scannedDate":"a2sIp_1dLIgXgPZf"};